import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import Menu from "../../accounting/Menu";
import Transfers from "../../../modules/presence/transfers/transfers";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("transfers");
    this.props.setMenuLeftContent(Menu);
    this.props.setMenuLeftIndex("transfers");
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return (
      <Transfers />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/presence/transfers/Home.js